"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var NavContext = /*#__PURE__*/_react.default.createContext({
  withinNav: false,
  activeKey: null,
  onSelect: _noop.default
});

var _default = NavContext;
exports.default = _default;